module.exports = __webpack_public_path__ + "static/media/amir_jaan.5ae46675.jpg";